import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [openModals, setOpenModals] = useState(new Set());

  const openModal = useCallback((modalId) => {
    setOpenModals((prev) => {
      const next = new Set([...prev, modalId]);
      //console.log('[ModalContext] Opening modal:', modalId, '| Open modals:', Array.from(next));
      return next;
    });
  }, []);

  const closeModal = useCallback((modalId) => {
    setOpenModals((prev) => {
      const next = new Set(prev);
      next.delete(modalId);
      //console.log('[ModalContext] Closing modal:', modalId, '| Open modals:', Array.from(next));
      return next;
    });
  }, []);

  const hasOpenModals = openModals.size > 0;

  return (
    <ModalContext.Provider value={{ openModal, closeModal, hasOpenModals, openModals }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
};
